import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Confidentialite() {
  return (
    <>
      <Helmet>
        <title>Politique de confidentialité | LMFP Photography</title>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.lmfp-photography.com/confidentialite" />
        <meta name="description" content="Consultez la politique de confidentialité de LMFP Photography : collecte, utilisation et protection de vos données personnelles." />
      </Helmet>

      <div className="min-h-screen bg-gray-900 text-white px-4 py-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden">
            <div className="px-8 pt-10 pb-6 border-b border-white/10">
              <p className="uppercase tracking-[0.3em] text-xs text-gray-400 mb-3">
                LMFP Photography
              </p>
              <h1 className="text-3xl md:text-4xl font-bold mb-3">
                Politique de confidentialité
              </h1>
              <p className="text-gray-400 text-sm md:text-base max-w-2xl">
                Cette politique explique comment LMFP Photography collecte,
                utilise et protège les données personnelles des utilisateurs du
                site.
              </p>
            </div>

            <div className="px-8 py-8 space-y-8 text-sm md:text-base text-gray-200 leading-7">
              <section>
                <h2 className="text-xl font-semibold text-white mb-3">1. Introduction</h2>
                <p>
                  La présente politique de confidentialité explique comment LMFP
                  Photography collecte, utilise et protège les données
                  personnelles des utilisateurs du site.
                </p>
                <p className="mt-3">
                  LMFP Photography s'engage à traiter les données personnelles
                  dans le respect de la réglementation applicable.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">2. Responsable du traitement</h2>
                <p>Le responsable du traitement est : Schroeders Geoffrey</p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>Nom / activité : LMFP Photography</li>
                  <li>Responsable : Schroeders Geoffrey</li>
                  <li>Email de contact : lmfp.photography@gmail.com</li>
                  <li>Pays : Belgique</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">3. Données collectées</h2>
                <p>
                  Lors de l'inscription ou de l'utilisation du site, les données
                  suivantes peuvent être collectées :
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>prénom ;</li>
                  <li>nom ;</li>
                  <li>adresse email ;</li>
                  <li>date de naissance ;</li>
                  <li>mot de passe chiffré ;</li>
                  <li>rôle utilisateur ;</li>
                  <li>date d'acceptation des conditions ;</li>
                  <li>version des conditions acceptées ;</li>
                  <li>toute information transmise volontairement via les formulaires ou fonctionnalités du site.</li>
                </ul>
                <p className="mt-3">
                  Des données techniques peuvent également être collectées pour le
                  bon fonctionnement et la sécurité du site.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">4. Finalités du traitement</h2>
                <p>Les données personnelles sont utilisées pour :</p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>créer et gérer le compte utilisateur ;</li>
                  <li>permettre l'accès à l'espace personnel ;</li>
                  <li>assurer le bon fonctionnement du site ;</li>
                  <li>sécuriser la plateforme et prévenir les abus ;</li>
                  <li>communiquer avec l'utilisateur si nécessaire ;</li>
                  <li>respecter les obligations légales.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">5. Base légale du traitement</h2>
                <p>Les traitements reposent selon les cas sur :</p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>l'exécution du service demandé par l'utilisateur ;</li>
                  <li>le respect d'obligations légales ;</li>
                  <li>l'intérêt légitime lié à la sécurité, à la gestion technique et à la protection de la plateforme.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">6. Destinataires des données</h2>
                <p>
                  Les données personnelles sont accessibles uniquement aux
                  personnes ou prestataires qui en ont besoin pour le
                  fonctionnement du site, dans la limite de leurs missions.
                </p>
                <p className="mt-3">Les données ne sont pas vendues à des tiers.</p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">7. Durée de conservation</h2>
                <p>
                  Les données sont conservées pendant une durée limitée et
                  proportionnée aux finalités poursuivies.
                </p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>les données du compte sont conservées tant que le compte est actif ;</li>
                  <li>certaines données peuvent être conservées plus longtemps si la loi l'impose ou si cela est nécessaire pour la gestion d'un litige, la preuve d'un consentement ou la sécurité de la plateforme.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">8. Sécurité</h2>
                <p>
                  LMFP Photography met en place des mesures techniques et
                  organisationnelles raisonnables afin de protéger les données
                  personnelles contre la perte, l'accès non autorisé, l'altération
                  ou la divulgation.
                </p>
                <p className="mt-3">
                  Malgré ces efforts, aucun système n'est totalement exempt de risques.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">9. Droits des utilisateurs</h2>
                <p>L'utilisateur peut, dans les conditions prévues par la loi :</p>
                <ul className="list-disc pl-6 mt-3 space-y-1 text-gray-300">
                  <li>demander l'accès à ses données personnelles ;</li>
                  <li>demander la rectification de données inexactes ;</li>
                  <li>demander l'effacement de ses données ;</li>
                  <li>demander la limitation du traitement ;</li>
                  <li>s'opposer à certains traitements ;</li>
                  <li>demander la portabilité de ses données lorsque cela s'applique.</li>
                </ul>
                <p className="mt-3">
                  Toute demande peut être adressée à : lmfp.photography@gmail.com.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">10. Cookies et traceurs</h2>
                <p>
                  Le site peut utiliser des cookies ou outils techniques
                  nécessaires à son fonctionnement.
                </p>
                <p className="mt-3">
                  Si des cookies non essentiels sont utilisés ultérieurement, une
                  information spécifique et, si nécessaire, un mécanisme de
                  consentement adapté seront mis en place.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">11. Modification de la politique</h2>
                <p>
                  LMFP Photography peut modifier la présente politique de
                  confidentialité à tout moment afin de refléter une évolution
                  légale, technique ou fonctionnelle.
                </p>
                <p className="mt-3">
                  La version en vigueur est celle publiée sur le site à la date de consultation.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">12. Contact</h2>
                <p>
                  Pour toute question relative à la présente politique de
                  confidentialité ou au traitement des données personnelles :
                </p>
                <p className="mt-3">Email : lmfp.photography@gmail.com</p>
              </section>

              <div className="pt-4 border-t border-white/10 space-y-4">
                <p className="text-xs text-gray-500 text-center">
                  Site réalisé par Schroeders Benjamin
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/register"
                    className="inline-block px-6 py-3 rounded-xl bg-white text-black font-semibold hover:bg-gray-200 transition text-center"
                  >
                    Retour à l'inscription
                  </Link>
                  <Link
                    to="/cgu"
                    className="inline-block px-6 py-3 rounded-xl border border-white/15 text-white hover:bg-white/10 transition text-center"
                  >
                    Voir les CGU
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Confidentialite;